function FacebookSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={props.size || "40"}
      height={props.size || "40"}
      viewBox="0 0 612 612"
      xmlSpace="preserve"
      {...props}
    >
      {/* Fondo circular */}
      <path
        fill={props.fillCircle || "#000"}  // Color del círculo (por defecto, azul)
        d="M612 306C612 137.004 474.995 0 306 0 137.004 0 0 137.004 0 306c0 168.995 137.004 306 306 306 168.995 0 306-137.005 306-306z"
      />
      {/* Letra "F" */}
      <path
        fill="#FFF" 
        d="M223.825 306v-58.557h35.885V212.03c0-47.764 14.271-82.175 66.569-82.175h62.201v58.418h-43.785c-21.949 0-26.929 14.577-26.929 29.849v29.32h67.487L376.046 306h-58.278v176.617H259.71V306h-35.885z"
      />
    </svg>
  );
}

export default FacebookSvg;
